module.exports = __webpack_public_path__ + "img/workflow-sent-success.4aadaf92.gif";